import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const SharedPhotosPageSkeleton: React.FC = () => (
  <div className="space-y-4">
    <div className="space-y-2">
      <Skeleton className="h-7 w-56" />
      <Skeleton className="h-4 w-40" />
    </div>
    <Skeleton className="h-9 w-44" />
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-5">
      {Array.from({ length: 10 }).map((_, i) => (
        <Skeleton key={i} className="aspect-square w-full rounded-md" />
      ))}
    </div>
  </div>
)

export default SharedPhotosPageSkeleton
